import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_ENDPOINTS from '../ApiEndPoints';

const NotesDetail = ({ noteId }) => {
  const [note, setNote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancel = false;
    async function load() {
      if (!noteId) return;
      setLoading(true);
      setError(null);
      try {
        const { data } = await axios.get(API_ENDPOINTS.notes.show(noteId));
        if (!cancel) setNote(data);
      } catch (e) {
        if (!cancel) setError('Unable to load note');
      } finally {
        if (!cancel) setLoading(false);
      }
    }
    load();
    return () => {
      cancel = true;
    };
  }, [noteId]);

  if (!noteId) {
    return (
      <div className="panel panel-default">
        <div className="panel-body text-muted">Select a note to see details</div>
      </div>
    );
  }

  if (loading) {
    return <div className="text-muted">Loading…</div>;
  }
  if (error) {
    return <div className="text-danger">{error}</div>;
  }
  if (!note) return null;

  return (
    <div className="panel panel-default">
      <div className="panel-heading">
        <strong>{note.title || `Note #${note.id}`}</strong>
        <span className="pull-right text-muted" style={{ fontSize: 12 }}>
          {note.created_at && new Date(note.created_at).toLocaleString()}
        </span>
      </div>
      {note.owner && (
        <div className="panel-body" style={{ paddingTop: 0, paddingBottom: 8 }}>
          <span className="text-muted" style={{ fontSize: 12 }}>By: {note.owner.name} (User #{note.owner.id})</span>
        </div>
      )}
      <div className="panel-body" style={{ whiteSpace: 'pre-wrap' }}>
        {note.description || <span className="text-muted">No description</span>}
      </div>
      <div className="panel-body" style={{ paddingTop: 0 }}>
        <div className="row" style={{ fontSize: 12 }}>
          <div className="col-sm-6">
            <div><strong>Note ID:</strong> {note.id}</div>
            <div><strong>UID:</strong> {note.uid || <span className="text-muted">n/a</span>}</div>
            <div><strong>Type ID:</strong> {note.type_id ?? 'n/a'}</div>
            <div><strong>Category ID:</strong> {note.category_id ?? 'n/a'}</div>
          </div>
          <div className="col-sm-6">
            <div><strong>Parent Instance ID:</strong> {note.parent_object_instances_id ?? <span className="text-muted">none</span>}</div>
            <div><strong>Object Definition ID:</strong> {note.object_definitions_id ?? <span className="text-muted">none</span>}</div>
          </div>
        </div>
      </div>
      {note.parent && (
        <div className="panel-footer">
          <div>
            <span className="text-muted">Parent:</span>{' '}
            {note.parent.url ? (
              <a href={note.parent.url} target="_blank" rel="noreferrer">
                {note.parent.title} ({note.parent.type_title || note.parent.kind} #{note.parent.id})
              </a>
            ) : (
              <span>{note.parent.title} ({note.parent.type_title || note.parent.kind} #{note.parent.id})</span>
            )}
          </div>
          <div className="text-muted" style={{ fontSize: 12, marginTop: 4 }}>
            {note.parent.tid && (<span style={{ marginRight: 12 }}>TID: {note.parent.tid}</span>)}
            {typeof note.parent.owner_id !== 'undefined' && note.parent.owner_id !== null && (
              <span>Owner ID: {note.parent.owner_id}</span>
            )}
          </div>
          {note.parent.description && (
            <div style={{ marginTop: 6, whiteSpace: 'pre-wrap' }}>
              {note.parent.description}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotesDetail;
